export default function RefHero() {
  return (
    <section className="pt-32 pb-16 bg-zinc-950 border-b border-zinc-800/60">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-zinc-800/60 border border-zinc-700/40 rounded-full px-4 py-1.5 mb-6">
          <i className="ri-layout-grid-line text-orange-400 text-sm" />
          <span className="text-zinc-300 text-sm font-semibold">Portfólio</span>
        </div>
        <h1 className="text-5xl md:text-6xl font-black text-white mb-5 leading-tight">
          Naše práce{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-400">
            hovoria za nás
          </span>
        </h1>
        <p className="text-zinc-400 text-lg max-w-2xl mx-auto mb-10">
          Projekty od nuly aj kompletné redesigny. Každý s reálnymi číslami a príbehom.
          Potiahnite pred/po slider, aby ste sami videli rozdiel.
        </p>

        {/* Stats row */}
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-16">
          {[
            { value: '8+', label: 'Dokončených projektov' },
            { value: '2', label: 'Typy: Od nuly & Redesign' },
            { value: '€4.2M+', label: 'Tržby pre klientov' },
            { value: '100%', label: 'SK tím' },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-2xl md:text-3xl font-black text-orange-400">{s.value}</div>
              <div className="text-xs text-zinc-500 mt-0.5 whitespace-nowrap">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
